import Vue from 'vue';
import stockData from './stock-data/stock-data.vue';
Vue.component('stock-data', stockData);
